import React from "react";
import { DialogTitle, DialogContent, Typography } from "@mui/material";
import "./OrderLogPopup.css";
import PopupWrapper from "../popupWrapper/popupWrapper";

const OrderLogPopup = ({ onClose, logs }) => {
  return (
    <PopupWrapper onClose={onClose}>
      <div className="log-popup-header">
        <Typography variant="h6">Log details</Typography>
      </div>
      <div>
        <div className="log-popup-content">
          {logs?.map((log, index) => (
            <div className="log-item" key={index}>
              {/* Timestamp */}
              <Typography className="log-timestamp">{log.timestamp}</Typography>

              {/* Dot and Timeline */}
              <div className="log-dot-wrapper">
                <div className="log-dot" />
                {index < logs?.length - 1 && <div className="timeline-line" />}
              </div>

              {/* Log Content */}
              <div className="log-details">
                <Typography className="log-title">{log.title}</Typography>
                <Typography className="log-user">{`by ${log?.user}`}</Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PopupWrapper>
  );
};

export default OrderLogPopup;
